var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-submit-buttons"},[_c('div',{staticClass:"footer-submit-buttons-fixed"},[(_vm.cancel)?_c('el-button',{attrs:{"type":"default"},on:{"click":_vm.handleClickCancel}},[_vm._v(" 取消 ")]):_vm._e(),_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.handleSubmit}},[_vm._v(" 保存 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }